import { render, staticRenderFns } from "./PaperContrast.vue?vue&type=template&id=427431d6&scoped=true"
import script from "./PaperContrast.vue?vue&type=script&lang=js"
export * from "./PaperContrast.vue?vue&type=script&lang=js"
import style0 from "./PaperContrast.vue?vue&type=style&index=0&id=427431d6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "427431d6",
  null
  
)

export default component.exports